//注入按钮
import '../utils';
import "./sysButton";
import '../filters'
import mobileDirectives from "./directives";
import { DsfMobileTeasLearning, DsfTeasLearningSchedule, DsfMobileTeasNewLearningSchedule } from "./teasLearning";
import { DsfMobileTeasScheduleList } from "./teasScheduleList";
import { DsfMobileTeasStudentClassList } from "./teasClasssList";
import { DsfMobileTeasAssess } from "./teasAssess";
import { DsfMobileTeasAssessList } from "./teasAssessList";
import { DsfMobileTeasReportDuty } from "./teasReportDuty";
import { DsfMobileTeasTwoBring } from "./teasTwoBring";
import { DsfMobileTeasMyAskLeave } from "./teasMyAskLeave";
import { DsfMobileAlumniDirectory , DsfMobileNewAlumniDirectory } from "./alumniDirectory";
import { DsfMobileTeasHomeTopInfoView } from "./teasHomeTopInfoView";
import { DsfMobileTeasMyTodo } from "./teasMyTodo";
import { DsfMobileScheduleCalendar,DsfMobileYearScheduleCalendar } from "./scheduleCalendar";
import { DsfMobileTeasMySchedule } from "./teasMySchedule";
import { DsfMobileTeasMySeat } from "./teasMySeat";
import { DsfMobileTeasLectureAddressBookDetail } from "./teasLectureAddressBookDetail";
import { DsfMobileLoginPage } from "./loginPage";
import { DsfMobileTeasBufferPage } from "./teasBufferPage";
import { DsfMobileTeasTodayCourse } from "./teasTodayCourse";
import { DsfMobileTeasClassAlbumDetails,DsfMobileTeasClassAlbumList } from "./teasclassAlbum";
import { DsfMobileTeasMbDoubleHundredPoints } from "./teasMbDoubleHundredPoints";
import { DsfMobileTeasMbDbPointModule } from "./teasMbDoubleHundredPoints"
import voiceService from "./voiceService/mobileVoiceWakeUp";
import { DsfMobileTeasMealApplicationList } from "./mealApplication";
import { DsfMobileTeasManagementMeetingsList } from "./managementMeetings";
import {
  DsfMobileTeasAttendanceDetail,
  DsfMobileTeasClassInfo,
  DsfMobileTeasStaffWubie,
  DsfMobileTeasStudentWubie,
  DsfMobileTeasCourseInfo,
  DsfMobileTeasStudentCourse,
  DsfMobileTeasStudentWubieDetail,
} from './teasAttendance';
import { DsfMobileTeasSignInDetailList } from './teasSignInDetailList';
import { DsfMobileTeasModifyPassword } from './teasModifyPassword';
import { DsfMobileTeasOnlineSignUpCustomFrom } from './teasOnlineSignUpCustomFrom';
import { DsfMobileTeasAssessIframe } from './teasAssessIframe';
import { DsfMobileTeasCell,DsfMobileTeasCellItem } from './teasCell';
import { DsfMobileTeasSeal } from './teasSeal';
import { DsfMobileResourcesList,DsfMobileBatchOccupation,DsfMobileSelectField,DsfMobileBatchOccupationForm} from './teasTeachingResources';
import { DsfMobileTeasCardDesc,DsfMobileTeasCardDescItem } from './teasCardDesc';
import * as teasUniteComponents from "./teasUnite";
import * as historicalSubmission from "./commentsAndSuggestions";
const components = [
  DsfMobileTeasLearning,
  DsfMobileTeasScheduleList,
  DsfMobileTeasAssess,
  DsfMobileTeasAssessList,
  DsfMobileTeasReportDuty,
  DsfMobileTeasTwoBring,
  DsfMobileTeasMyAskLeave,
  DsfMobileTeasAttendanceDetail,
  DsfMobileTeasSignInDetailList,
  DsfMobileTeasClassInfo,
  DsfMobileTeasStaffWubie,
  DsfMobileTeasStudentWubie,
  DsfMobileTeasStudentWubieDetail,
  DsfMobileAlumniDirectory,
  DsfMobileNewAlumniDirectory,
  DsfMobileTeasHomeTopInfoView,
  DsfMobileTeasMyTodo,
  DsfMobileScheduleCalendar,
  DsfMobileYearScheduleCalendar,
  DsfMobileTeasMySchedule,
  DsfMobileTeasMySeat,
  DsfMobileTeasLectureAddressBookDetail,
  DsfMobileLoginPage,
  DsfMobileTeasCourseInfo,
  DsfMobileTeasStudentClassList,
  DsfTeasLearningSchedule,
  DsfMobileTeasNewLearningSchedule,
  DsfMobileTeasStudentCourse,
  DsfMobileTeasAssessIframe,
  DsfMobileTeasClassAlbumDetails,
  DsfMobileTeasClassAlbumList,
  DsfMobileTeasMbDoubleHundredPoints,
  DsfMobileTeasMbDbPointModule,
  DsfMobileTeasBufferPage,
  DsfMobileTeasTodayCourse,
  DsfMobileTeasModifyPassword,
  DsfMobileTeasOnlineSignUpCustomFrom,
  DsfMobileTeasCell,
  DsfMobileTeasCellItem,
  DsfMobileTeasSeal,
  DsfMobileTeasCardDesc,
  DsfMobileTeasCardDescItem,
  DsfMobileTeasMealApplicationList,
  DsfMobileTeasManagementMeetingsList,
  DsfMobileResourcesList,
  DsfMobileBatchOccupation,
  DsfMobileSelectField,
  DsfMobileBatchOccupationForm,
  ...Object.values(teasUniteComponents),
  ...Object.values(historicalSubmission)
]
function install(Vue) {
  Vue.use(mobileDirectives);
  components.forEach((it) => {
    Vue.component(it.name, it);
    if (!window.$components['teas']) {
      window.$components['teas'] = {}
    }
    window.$components['teas'][it.name] = it;
  })
}


export default install;
export { install , voiceService};
